module.exports = __webpack_public_path__ + "static/media/floor5.8888e32c.png";